let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7iVyy")).then(() => parcelRequire('8HFBO'));